import React, { useState } from 'react'; // اضافه کردن useState
import { FaShieldAlt, FaPlus, FaMinus, FaLightbulb } from "react-icons/fa";
import styles from '../../pages/Monitor/Monitor.module.css';

const SecurityCard = ({ data, onUpdate }) => {
    // ۱. تعریف وضعیت برای گسترش زون‌ها و رله‌ها
    const [isZonesExpanded, setIsZonesExpanded] = useState(false);
    const [isRelaysExpanded, setIsRelaysExpanded] = useState(false);

    if (!data) return null;

    const { status, settings, triggered, causedBy } = data;
    const isArmed = settings?.enable === "1";

    // پارس کردن مناطق فعال (0-32)
    const activeZones = settings?.zone ? settings.zone.split(',').map(Number) : [];

    // پارس کردن خروجی‌های متصل (0-71)
    const activeRelays = settings?.toDOut ? settings.toDOut.split(',').map(Number) : [];

    // تابع تغییر وضعیت زون‌ها
    const toggleZone = (zoneId) => {
        let newZones;
        if (activeZones.includes(zoneId)) {
            newZones = activeZones.filter(z => z !== zoneId);
        } else {
            newZones = [...activeZones, zoneId].sort((a, b) => a - b);
        }
        onUpdate('zone', newZones.join(','));
    };

    // تابع تغییر وضعیت خروجی‌ها (Relays)
    const toggleRelay = (relayId) => {
        let newRelays;
        if (activeRelays.includes(relayId)) {
            newRelays = activeRelays.filter(r => r !== relayId);
        } else {
            newRelays = [...activeRelays, relayId].sort((a, b) => a - b);
        }
        onUpdate('toDOut', newRelays.join(','));
    };

    // ۲. تعیین لیست‌های نمایشی
    const displayedZones = [...Array(isZonesExpanded ? 33 : 8).keys()];
    const displayedRelays = [...Array(isRelaysExpanded ? 72 : 8).keys()];

    return (
        <div className={styles.sensorCard}  style={{ borderRight: '4px solid #e74c3c' }}>
            <div className={styles.cardHeader}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <FaShieldAlt color={isArmed ? "#2ecc71" : "#95a5a6"} />
                    <span style={{ fontWeight: 'bold' }}>سیستم حفاظتی (Security)</span>
                </div>
                
                <FaLightbulb 
                    className={`${styles.trigIcon} ${triggered ? styles.trigOn : styles.trigOff}`}
                    title={triggered ? "تشخیص حرکت" : "وضعیت عادی"}
                    style={{ fontSize: '18px' }}
                />
            </div>

            <div className={styles.centerStatus}>
                <div style={{ fontSize: '20px', color: status === "1" ? "#e74c3c" : "#2ecc71", fontWeight: 'bold' }}>
                    {status === "1" ? "⚠️ هشدار فعال" : "✅ وضعیت عادی"}
                </div>
                {causedBy && <small style={{ color: '#f1c40f', fontFamily: 'monospace' }}>ZONE: {causedBy}</small>}
            </div>

            <div className={styles.settingsGroup}>
                {/* فعال‌سازی */}
                <div className={styles.settingRow}>
                    <span>فعال‌سازی سیستم:</span>
                    <label className={styles.toggleSwitch}>
                        <input 
                            type="checkbox" 
                            checked={isArmed} 
                            onChange={(e) => onUpdate('enable', e.target.checked ? "1" : "0")} 
                        />
                        <span className={styles.slider}></span>
                    </label>
                </div>

                {/* مناطق فعال (Zones) */}
                <div className={styles.settingRow} style={{ flexDirection: 'column', alignItems: 'flex-start', borderTop: '1px solid #ffffff10', paddingTop: '10px' }}>
                    <span style={{ fontSize: '12px', color: '#95a5a6' }}>مناطق تحت حفاظت ({isZonesExpanded ? '۰-۳۲' : '۰-۷'}):</span>
                    <div style={{  display: 'flex', 
                        flexWrap: 'wrap', 
                        gap: '4px', 
                        padding: '6px',
                        background: 'rgba(0,0,0,0.15)',
                        borderRadius: '6px',
                        width: '100%',
                        border: '1px solid rgba(255,255,255,0.05)' }}>
                        {displayedZones.map(z => (
                            <button 
                                key={z}
                                type="button"
                                onClick={() => toggleZone(z)}
                                style={{
                                    backgroundColor: activeZones.includes(z) ? '#e74c3c' : '#34495e',
                                    width: '22px',
                                    height: '22px',
                                    fontSize: '9px',
                                    border: 'none', 
                                    color: 'white', 
                                    borderRadius: '3px', 
                                    cursor: 'pointer',
                                    transition: '0.2s'
                                }}
                            >
                                {z}
                            </button>
                        ))}
                        {/* دکمه نارنجی رترو برای زون‌ها */}
                        <button 
                            type="button"
                            className={styles.retroToggleBtn}
                            onClick={() => setIsZonesExpanded(!isZonesExpanded)}
                        >
                            {isZonesExpanded ? <FaMinus /> : <FaPlus />}
                        </button>
                    </div>
                </div>

                {/* خروجی‌های متصل (Relays) */}
                <div className={styles.settingRow} style={{ flexDirection: 'column', alignItems: 'flex-start', borderTop: '1px solid #ffffff10', paddingTop: '10px' }}>
                    <span style={{ fontSize: '12px', color: '#3498db' }}>اتصال به خروجی‌ها ({isRelaysExpanded ? '۰-۷۱' : '۰-۷'}):</span>
                    <div style={{ 
                        display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '5px',
                        padding: '6px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '5px', width: '100%'
                    }}>
                        {displayedRelays.map(r => (
                            <button 
                                key={r}
                                type="button"
                                onClick={() => toggleRelay(r)}
                                style={{
                                    width: '22px', height: '22px', fontSize: '9px',
                                    backgroundColor: activeRelays.includes(r) ? '#2ecc71' : '#34495e',
                                    border: 'none', color: 'white', borderRadius: '3px', cursor: 'pointer'
                                }}
                            >
                                {r}
                            </button>
                        ))}
                        {/* دکمه نارنجی رترو برای رله‌ها */}
                        <button 
                            type="button"
                            className={styles.retroToggleBtn}
                            onClick={() => setIsRelaysExpanded(!isRelaysExpanded)}
                        >
                            {isRelaysExpanded ? <FaMinus /> : <FaPlus />}
                        </button>
                    </div>
                </div>

                {/* سایر تنظیمات */}
                <div className={styles.settingRow} style={{ marginTop: '10px' }}>
                    <span style={{ fontSize: '11px' }}>تاخیر مسلح شدن:</span>
                    <input className={styles.inputNum} style={{ width: '72px' }} value={settings?.armDelay || ""} onChange={(e) => onUpdate('armDelay', e.target.value)} />
                </div>

                <div className={styles.settingRow}>
                    <span style={{ fontSize: '11px' }}>تاخیر واکنش:</span>
                    <input className={styles.inputNum} style={{ width: '72px' }} value={settings?.reactDelay || ""} onChange={(e) => onUpdate('reactDelay', e.target.value)} />
                </div>

                <div className={styles.settingRow}>
                    <span style={{ fontSize: '11px' }}>مدت آژیر (Sec):</span>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <input className={styles.inputNum} style={{ width: '50px' }} value={settings?.timeout || ""} onChange={(e) => onUpdate('timeout', e.target.value)} />
                        <label style={{ fontSize: '10px', display: 'flex', alignItems: 'center', gap: '3px' }}>
                            پیامک: <input type="checkbox" checked={settings?.alertSms === "1"} onChange={(e) => onUpdate('alertSms', e.target.checked ? "1" : "0")} />
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SecurityCard;
